(() => {
    const emailCta = document.getElementById("email-cta")
    emailCta.addEventListener("click", () => {
        emailCta.textContent = "james at jamesantrobus dot com"
    }, { once: true })
})()